import { createSelector } from "@ngrx/store";
import { type MeetBackgroundState } from "./meet-background.interface";
import {
  DELETE_MEET_BACKGROUND_SUCCESS,
  GET_MEET_BACKGROUNDS,
  GET_MEET_BACKGROUNDS_FAILURE,
  GET_MEET_BACKGROUNDS_SUCCESS,
  type MeetBackgroundActions,
} from "./meet-background.actions";

export const initialMeetBackgroundState: MeetBackgroundState = {
  meetBackgrounds: null,
  loading: false,
  error: undefined,
};

export function meetBackgroundReducer(
  state: MeetBackgroundState = initialMeetBackgroundState,
  action: MeetBackgroundActions,
): MeetBackgroundState {
  switch (action.type) {
    case GET_MEET_BACKGROUNDS:
      return {
        ...state,
        loading: true,
        error: undefined,
      };
    case GET_MEET_BACKGROUNDS_SUCCESS:
      return {
        ...state,
        meetBackgrounds: action.payload,
        loading: false,
      };
    case GET_MEET_BACKGROUNDS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case DELETE_MEET_BACKGROUND_SUCCESS:
      return {
        ...state,
        meetBackgrounds: (state.meetBackgrounds ?? []).filter(
          (b) => b.meetBackgroundId !== action.payload,
        ),
      };
    default:
      return state;
  }
}

export const getMeetBackgroundRootState = (state: {
  meetBackground: MeetBackgroundState;
}): MeetBackgroundState => state.meetBackground;

export const getMeetBackgroundList = createSelector(
  getMeetBackgroundRootState,
  (s) => s.meetBackgrounds,
);

export const getMeetBackgroundLoading = createSelector(
  getMeetBackgroundRootState,
  (s) => s.loading,
);
